import { render } from "./CurrencyPicker.vue?vue&type=template&id=3dda321c"
import script from "./CurrencyPicker.vue?vue&type=script&lang=js"
export * from "./CurrencyPicker.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__